import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '@/context/StoreContext';
import { productPath } from '@/lib/api';
import { WishlistButton } from '@/components/WishlistButton';

export const ProductCard = ({ product, index = 0 }) => {
  const { t, lang, formatPrice } = useStore();
  const img = (product.images || [])[0];
  const alt = `${product.name} — ${product.estate || ''}${product.vintage && product.vintage !== 'NV' ? ` ${product.vintage}` : ''}, ${product.format}`.replace(' — ,', ' —');
  const priceLabel = formatPrice(product.price_eur);
  const soldOut = product.stock <= 0 || product.availability === 'out_of_stock';
  const lowStock = !soldOut && product.stock > 0 && product.stock <= 6;
  return (
    <article className="group relative">
      <Link to={productPath(product)} data-testid={`product-card-${product.reference_id}`} className="block" aria-label={product.name}>
        <div className="relative overflow-hidden bg-nw-espresso border border-nw-gold/15" style={{ aspectRatio: '3 / 4' }}>
          {img ? (
            <img src={img} alt={alt} loading={index < 4 ? 'eager' : 'lazy'} decoding="async"
              className={`w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05] ${soldOut ? 'opacity-40 grayscale' : 'opacity-95'}`} />
          ) : <div className="w-full h-full bg-nw-espresso" />}
          <div className="absolute inset-0 bg-gradient-to-t from-nw-black/70 via-transparent to-transparent" />
          {product.rarity === 'collector' && (
            <span className="absolute top-3 left-3 text-[9px] tracking-luxe uppercase text-nw-gold border border-nw-gold/50 px-2 py-1 bg-nw-black/50">Collector</span>
          )}
          {soldOut && (
            <span data-testid={`soldout-badge-${product.reference_id}`}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[10px] tracking-luxe uppercase text-nw-ivory bg-nw-black/85 border border-nw-ivory/40 px-4 py-2">
              {t.product.outStock}
            </span>
          )}
          {lowStock && (
            <span data-testid={`lowstock-badge-${product.reference_id}`}
              className="absolute bottom-3 left-3 text-[9px] tracking-luxe uppercase text-nw-black bg-nw-gold/95 px-2 py-1">
              {t.product.onlyLeft.replace('{n}', product.stock)}
            </span>
          )}
          {product.recently_restocked && !soldOut && (
            <span data-testid={`restocked-ribbon-${product.reference_id}`} aria-label={t.product.backInCellar}
              className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 text-[9px] tracking-luxe uppercase text-nw-black bg-nw-gold/95 px-2 py-1 shadow-[0_2px_10px_rgba(0,0,0,0.35)]">
              <span className="h-1 w-1 rounded-full bg-nw-black/70" aria-hidden="true" />{t.product.backInCellar}
            </span>
          )}
        </div>
        <div className="pt-4 text-center">
          <div className="text-[10px] tracking-luxe uppercase text-nw-warmgrey">{product.subcategory}{product.vintage ? ` · ${product.vintage}` : ''}</div>
          <h3 className="mt-1 font-serif text-nw-ivory text-lg leading-snug group-hover:text-nw-gold transition-colors">{product.name}</h3>
          <div className="mt-2 text-nw-gold text-sm tracking-wide">{priceLabel}</div>
        </div>
      </Link>
      <WishlistButton product={product} className="absolute top-3 right-3 opacity-80 group-hover:opacity-100" />
    </article>
  );
};
